import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Terminal, Check, Copy, ArrowUpRight } from 'lucide-react';

export const ContactSection: React.FC = () => {
  const { t } = useTranslation();
  const [copiedEmail, setCopiedEmail] = useState(false);

  const handleCopyEmail = () => {
    navigator.clipboard.writeText('luan.yata@gmail.com');
    setCopiedEmail(true);
    setTimeout(() => setCopiedEmail(false), 2000);
  };

  return (
    <section className="pt-16">
      <div className="bg-[#090C13] border border-[#00F0FF]/30 p-8 sm:p-10 font-mono relative">
        
        <div className="flex items-center space-x-2 text-xs text-[#00F0FF] mb-6">
          <Terminal size={16} />
          <span>{t('contact.badge')}</span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          
          <div className="lg:col-span-8 space-y-3">
            <h2 className="text-2xl sm:text-4xl font-bold text-white font-sans">
              {t('contact.headline')}
            </h2>
            <p className="text-gray-400 text-sm font-sans max-w-xl">
              {t('contact.subtitle')}
            </p>
          </div>

          <div className="lg:col-span-4 space-y-4">
            <button
              type="button"
              onClick={handleCopyEmail}
              className="w-full bg-[#00F0FF] text-[#07090E] font-bold py-3.5 px-4 flex items-center justify-center space-x-2 hover:bg-cyan-300 transition-all text-xs tracking-wider cursor-pointer"
            >
              {copiedEmail ? <Check size={16} /> : <Copy size={16} />}
              <span>{copiedEmail ? t('contact.copyBtnSuccess') : t('contact.copyBtnDefault')}</span>
            </button>

            <div className="flex items-center justify-between text-xs text-gray-400 pt-2 border-t border-gray-800">
              <a 
                href="https://www.linkedin.com/in/luanyata/" 
                target="_blank" 
                rel="noreferrer" 
                className="hover:text-[#00F0FF] transition-colors flex items-center space-x-1"
              >
                <span>LinkedIn</span>
                <ArrowUpRight size={12} />
              </a>
              <a 
                href="https://github.com/luanyata" 
                target="_blank" 
                rel="noreferrer" 
                className="hover:text-[#00F0FF] transition-colors flex items-center space-x-1"
              >
                <span>GitHub</span>
                <ArrowUpRight size={12} />
              </a>
            </div>
          </div>

        </div>

        <div className="mt-10 pt-6 border-t border-gray-800/80 text-center text-[11px] text-gray-500">
          {t('contact.copyright')}
        </div>

      </div>
    </section>
  );
};
